import { render, staticRenderFns } from "./crm-store-update-close.vue?vue&type=template&id=1b2f6684&scoped=true&"
import script from "./crm-store-update-close.vue?vue&type=script&lang=js&"
export * from "./crm-store-update-close.vue?vue&type=script&lang=js&"
import style0 from "./crm-store-update-close.vue?vue&type=style&index=0&id=1b2f6684&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2f6684",
  null
  
)

export default component.exports